import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import {
  Row,
  Col,
  Button,
  Skeleton,
  DatePicker,
  Form, 

} from "antd";
import { NavLink } from "react-router-dom";
import { PrinterOutlined } from "@ant-design/icons";
import LoginChecked from "../Shared/LoginChecked";
import { NumberFormat } from "../Shared/Utility";
import { IdentificationIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";
import moment from "moment";
function CapitalReport() {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const [loading, setLoading] = useState(false);
  const [FinalData, setFinalData] = useState({});
  const[ReceivableAmounr,setReceivableAmounr] = useState("");
  const[PayableAmount,setPayableAmount] = useState('');
  const [StartDate, SetStartDate] = useState("");
  const [EndDate, SetEndDate] = useState("");


  useEffect(() => {
    document.title = "Capital Report";
  }, []);

  const { RangePicker } = DatePicker;

  

  const disabledDate = (current) => {
      return current && current > moment().endOf("day");
    };

  return (
    <>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">
            Capital Working Report
            </h3>

            <div className="header-actions">
             
              <NavLink
                to={`/`}
                target="blank"
              >
                <Button
                  type="dashed"
                  shape="round"
                  size="large"
                  icon={<PrinterOutlined />}
                >
                  Print Report
                </Button>
              </NavLink>
            </div>
          </div>
          <div className="filter-wrap">
            <Form>
              <Form.Item>
                <RangePicker
                  allowClear
                  
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Form>
          </div>
          {loading ? (
            <>
              <Row>
                <Col xs={24} md={16}>
                  <Skeleton active />
                  <Skeleton active />
                </Col>
              </Row>
            </>
          ) : (
            <Row justify={"center"}>
               <Col md={20} sm={24}>
       
                <div className="fb-card">
                  <div className="fb-card-header">
                    <div className="fb-card-title">
                      <span>
                        <IdentificationIcon />
                        
                      </span>
                      <h4>CAPITAL REPORT DETAILS</h4>
                    </div>
                  </div>

                  <div className="fb-card-body table">
                    <ul className="profit-list">
                      <li >
                        <h4 style={{color:"black"}}>Cash Receivable: <br /><span style={{fontSize:"13px",color:"grey"}}>Taken From Cash Receivable report</span></h4>
                        <p>{FinalData.productBalance ? NumberFormat(FinalData.productBalance,0)  : 0}</p>
                      </li>
                      <li >
                        <h4 style={{color:"black"}}>Stock In Hand:<br /><span style={{fontSize:"13px",color:"grey"}}>Taken From Stock Details</span></h4>
                        <p> {FinalData.customerReceiveable ? NumberFormat(FinalData.customerReceiveable,0): 0}</p>
                      </li>
                      <li >
                        <h4 style={{color:"black"}}>Bank Balance:<br /><span style={{fontSize:"13px",color:"grey"}}>Taken From Cash At Bank In Dashboard</span></h4>
                        <p>{FinalData.bankBalance ? NumberFormat(FinalData.bankBalance,0) : 0}</p>
                      </li>
                      <li >
                        <h4 style={{color:"black"}}>Cash<br /><span style={{fontSize:"13px",color:"grey"}}>Taken From Cash At Hand In Dashboard</span></h4>
                        <p >{FinalData.cashBalance ? NumberFormat(FinalData.cashBalance,0)  : 0}</p>
                      </li>
                      <li >
                        <h4 style={{color:"black"}}>Total Investment</h4>
                        <p >{FinalData ? NumberFormat(ReceivableAmounr,0) : 0}</p>
                      </li>
                      <li >
                        <h4 style={{color:"black"}}>Cash Payable<br /><span style={{fontSize:"13px",color:"grey"}}>Taken From Cash Payable Report</span></h4>
                        <p >{FinalData ? NumberFormat(ReceivableAmounr,0) : 0}</p>
                      </li>
                      <li >
                        <h4 style={{color:"black"}}>Net Investment</h4>
                        <p >{FinalData.supplierPayable ? NumberFormat(FinalData.customerPayable,0): 0}</p>
                      </li>
                     
                     
                      
                    </ul>
                  </div>
                </div>
              </Col>
      </Row>
          )}
        </div>
      </div>
      
    </>
  );
}

export default CapitalReport;
